// angular dependencies
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  signal,
} from '@angular/core';

/**
 * Tags of a game card, intended for use within `<fz-game-card>`.
 *
 * FzGameCardTagsComponent provides no behaviors, instead serving as a
 * purely visual treatment.
 */
@Component({
  selector: `fz-game-card-tags, [fz-game-card-tags], [fzGameCardTags]`,
  templateUrl: './game-card-tags.component.html',
  styleUrls: ['./game-card-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FzGameCardTagsComponent {
  @Input()
  tags?: string[];

  @Input()
  external? = false;

  @Input()
  variant?: 'text' | 'outlined' | 'contained' = 'contained';

  @Input()
  color?: 'primary' | 'accent' | 'warn' = 'primary';

  @Input()
  size?: 'small' | 'medium' | 'large' = 'medium';

  @Input()
  assetUrl? = '';

  priority = {
    'Charity Event': 1,
    'ZBO Only Tournament': 2,
    'Prize Tournament': 3,
    'Free Tournament': 4,
    'Cash Tournaments ': 5,
  };

  visible = signal(false);

  toggle(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.visible = signal(!this.visible());
  }
}
